import { FC, useMemo } from 'react';
import { TextButton } from 'components/uikit/buttons/TextButton.tsx';

import styles from './RoleModalBlock.module.scss';
import DeleteIcon from 'assets/icons/delete.svg?react';
import EditIcon from 'assets/icons/edit.svg?react';
import { ProjectRoleDto } from 'services/api/api-client.types.ts';

export type RoleModalBlockProps = {
  projectRole: ProjectRoleDto;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
};

export const RoleModalBlock: FC<RoleModalBlockProps> = (props) => {
  const roleSigners = useMemo(() => {
    return (
      props.projectRole.signers?.map(
        (dto) => `${dto.signer.firstName} ${dto.signer.lastName}`,
      ) ?? []
    );
  }, [props.projectRole.signers]);

  return (
    <div className={styles.wrapper} data-test-id={'role-card'}>
      <div className={styles.rightColumn}>
        <div className={styles.roleName} data-test-id={'role-name'}>
          {props.projectRole.name}
        </div>
        <div className={styles.signers} data-test-id={'role-signers'}>
          {roleSigners.map((e) => (
            <li key={e} className={styles.signer}>
              {e}
            </li>
          ))}
        </div>
      </div>
      <div className={styles.leftColumn}>
        <div className={styles.buttons}>
          <TextButton
            testId={'edit-button'}
            icon={<EditIcon />}
            className={styles.editButton}
            onClick={() => props.onEdit(props.projectRole.id)}
          />
          <TextButton
            testId={'delete-button'}
            icon={<DeleteIcon />}
            className={styles.deleteButton}
            onClick={() => props.onDelete(props.projectRole.id)}
          />
        </div>
      </div>
    </div>
  );
};
